import {FINDER_DETAIL_LOAD_DATA} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {clearElusiveDataForSubpanels} from '~/frontend/src/actions/elusiveData';
import dataLoadData from '~/frontend/src/actions/data/loadData';
import {
    LoadDetailDataParameters,
    LoadDetailDataResult
} from '~/shared/src/utilities/modules/finder';

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {Schema} schema
 * @param {Status} status
 * @param {string} timestamp
 * @param {string} timezone
 * @param {number} rootItemId
 * @param {string} [rootItemType]
 * @param {string} [rootItemKey]
 * @param {() => void} [successCallback]
 *
 * @return {Promise<void>}
 */
const loadData = ( panelKey : string, schema : Schema, status : Status, timestamp : string, timezone : string, rootItemId : number, rootItemType? : string, rootItemKey? : string, successCallback? : ( result : LoadDetailDataResult ) => void ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    dispatch( {
        type: FINDER_DETAIL_LOAD_DATA,
        panelKey,
        schema,
        status,
        timestamp,
        timezone,
        rootItemId,
        rootItemType,
        rootItemKey
    } );

    const params : LoadDetailDataParameters = {
        schema   : schema,
        status   : status,
        timestamp: timestamp,
        timezone : timezone,
        itemId   : rootItemId,
        itemType : rootItemType,
        itemKey  : rootItemKey
    };

    // clear global data
    global.data[ panelKey ] = {
        items     : {},
        references: {},
        schema
    };

    dispatch( clearElusiveDataForSubpanels( panelKey ) );

    await dispatch( dataLoadData(
        'finder/loadDetailData',
        panelKey,
        panelKey,
        'loadData',
        schema,
        {
            params,
            extraMetaDataKeys: [ 'referenceCounts' ]
        },
        undefined,
        successCallback
    ) );
}
export type LoadData = typeof loadData;

export default loadData;
